import loginSaga from './login/loginSaga';
import reserveSaga from './reserve/reserveSaga';

export default [
  loginSaga,
  reserveSaga
];
